import React, { useState } from 'react';
import StatGrid from './StatGrid';
import { teamStatistics, activeTeamSeason, statsForSeason } from '../../lib/clubHelpers';

export default function ClubStatistics({ data, nameMap }) {
  const ov = data?.overview || {};
  const all = teamStatistics(ov);
  const active = activeTeamSeason(ov);
  const [seasonId, setSeasonId] = useState(
    active?.id ?? (all[0]?.season_id ?? all[0]?.season?.id) ?? null,
  );

  const chosen = statsForSeason(ov, seasonId);
  const details = chosen?.details || [];

  return (
    <div>
      {all.length > 1 && (
        <div className="mb-4">
          <select
            className="i-search"
            style={{ maxWidth: 320 }}
            value={String(seasonId ?? '')}
            onChange={(e) => setSeasonId(e.target.value ? Number(e.target.value) : null)}
          >
            {all.map((s, i) => {
              const sid = s?.season_id ?? s?.season?.id;
              const nm = s?.season?.name || `Season ${i + 1}`;
              return (
                <option key={i} value={String(sid ?? '')}>
                  {nm}{s?.season?.is_current ? ' (current)' : ''}
                </option>
              );
            })}
          </select>
        </div>
      )}
      <StatGrid details={details} nameMap={nameMap} title="Statistics" />
    </div>
  );
}
